namespace $.$$ {

	export class $shm_hitalama_app_overlay extends $.$shm_hitalama_app_overlay {

		fullscreen_zoom_key() {
			return '$shm_hitalama_app_fullscreen.zoom'
		}

		fullscreen_zoom( next?: number ) {
			const stored = Number( this.$.$mol_state_local.value( this.fullscreen_zoom_key(), next ) ?? 1 )
			return Number.isFinite( stored ) ? Math.max( .5, Math.min( 2, stored ) ) : 1
		}

		@ $mol_action
		fullscreen_zoom_out( next?: Event | null ) {
			if( next ) this.fullscreen_zoom( Math.round( ( this.fullscreen_zoom() - .1 ) * 10 ) / 10 )
			return next ?? null
		}

		@ $mol_action
		fullscreen_zoom_in( next?: Event | null ) {
			if( next ) this.fullscreen_zoom( Math.round( ( this.fullscreen_zoom() + .1 ) * 10 ) / 10 )
			return next ?? null
		}

		hide_popover() {
			const overlay = this.dom_tree() as HTMLElement
			overlay.removeAttribute( 'popover' )
		}

		/** for place it above fullscreen popover */
		show_popover( force = false ) {
			const overlay = this.dom_tree() as HTMLElement
			if( force ) overlay.removeAttribute( 'popover' )
			if( overlay.popover !== 'manual' ) overlay.popover = 'manual'
			if( !overlay.matches( ':popover-open' ) ) overlay.showPopover()
		}

		overlayed_map_entity() {
			return this.$.$mol_error_fence(
				()=> $shm_hitalama_profile.current()?.overlayed_map() ?? null,
				()=> null,
				()=> null,
			)
		}

		overlayed_map_visible(): readonly $mol_view[] {
			const profile = this.$.$mol_error_fence(
				()=> $shm_hitalama_profile.current(),
				()=> null,
				()=> null,
			)
			if( !profile ) return []
			if( !profile.overlayed_map_enabled() ) return []

			const map = this.overlayed_map_entity()
			if( !map ) return []
			if( this.$.$mol_state_arg.value( 'settings' ) === 'overlayed_map' ) return []
			if( map.link().toString() === this.$.$mol_state_arg.value( 'map' ) ) return []

			return [ this.Overlayed_map() ]
		}

		fullscreen_close_uri() {
			const dict = this.$.$mol_state_arg.dict()
			return this.$.$mol_state_arg.link({ ...dict, fullscreen_widget: null, fullscreen_application: null })
		}

		fullscreen_panel(): readonly ( any )[] {
			return this.$.$mol_state_arg.value( 'fullscreen_widget' ) || this.$.$mol_state_arg.value( 'fullscreen_application' ) ? super.fullscreen_panel() : []
		}

	}

}
